import { useState } from "react";
import { FinanceDialog } from "../finance/FinanceDialog";
import { useLocale } from "../i18n";

export function DeleteOrganizationDialog({ organization, onClose, onSaved, onReload }: {
  organization: { id: string; name: string; version: number };
  onClose: () => void; onSaved: () => void; onReload: () => void;
}) {
  const { w } = useLocale();
  const [reason, setReason] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  return <FinanceDialog title={w("حذف المنشأة", "Delete organization")} description={organization.name}
    path="/organizationManagement/delete" payload={{ partyId: organization.id, expectedVersion: organization.version, reason: reason.trim() }}
    valid={confirmed && !!reason.trim()} submitLabel={w("تأكيد حذف المنشأة", "Confirm organization deletion")}
    onClose={onClose} onSaved={onSaved} onReload={onReload}>
    <p className="organization-warning">{w(
      "سيتم إخفاء المنشأة من القوائم ومنع الوصول إليها وإلغاء تعيينات العضوية المعلّقة. تبقى حسابات الأفراد والسجلات المالية والتاريخية محفوظة. هذا الإجراء لا يلغي أي فوترة خارجية تلقائياً.",
      "The organization will be hidden from lists, access will be removed, and pending membership assignments will be cancelled. Individual accounts and financial and historical records are preserved. This action does not automatically cancel external billing.")}</p>
    <label>{w("سبب الحذف", "Deletion reason")}<textarea required maxLength={500} value={reason} onChange={event => setReason(event.target.value)} /></label>
    <label className="organization-check"><input type="checkbox" required checked={confirmed} onChange={event => setConfirmed(event.target.checked)} />{w("أؤكد حذف هذه المنشأة ومنع الوصول إليها", "I confirm deleting this organization and removing access")}</label>
  </FinanceDialog>;
}
